import React,{useEffect,useState } from 'react';
import CheckListTable from '../components/tables/CheckListTable';
import { GET_CHECK_LIST } from '../constant'; 
import { Circles } from 'react-loader-spinner';
import axios from 'axios';
import {currentDateFormat} from "../utils";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';

//import Loader from '../components/loader/Loader';

function CheckList() {
//const [loading, setLoading] = useState(false);
const [checkList,setCheckList] = useState([]);
const [currentDate,setCurrentDate] = useState(new Date());
const dispatch = useDispatch();
//const loading = useSelector((state) => state.loader.loading);

  useEffect(()=>{
    dispatch(setLoading(true));
    axios.get(GET_CHECK_LIST)
    .then(response => {
      dispatch(setLoading(false));
       setCheckList(response.data);
     })
    .catch(error => {
       console.error(error);
     });
},[]);


  // if (loading) {
  //   return (<div className="loader-container">
  //       <Circles
  //         height="100"
  //         width="100"
  //         color="#4e8573"
  //         ariaLabel="circles-loading"
  //         wrapperStyle={{}}
  //         wrapperClass="circles-wrapper"
  //         visible={true}
  //       />
  //       <div className="spinner-overlay"></div>
  //     </div>
  //   )
  // }  
  return (
    <><section>
    <div className='d-flex justify-content-between form-container'>
          <div>
            <h2 className="fs-5 font-weight-600">Schedule List </h2>
          </div>
          <div>
            <span >{currentDateFormat(currentDate)}</span>
          </div>
        </div>
    </section>
    <section>
    <div className="create-schedule-table">
      <div className="table-responsive">
        <CheckListTable  tableData={checkList} />
      </div>
    </div>
  </section></>
  )
}

export default CheckList